{
  "sections": [
    {
      "id": "start",
      "label": "Start here",
      "items": [
        {
          "key": "interview_blueprint",
          "icon": "pi-map",
          "title": "Frontend interview preparation guide",
          "description": "How the rounds work, what interviewers score and a prep order for your timeline.",
          "route": "/guides/interview-blueprint/intro"
        },
        {
          "key": "plan_30d",
          "icon": "pi-calendar",
          "title": "30-day interview roadmap",
          "description": "A week-by-week plan across JavaScript, UI coding, frameworks and system design.",
          "route": "/tracks/foundations-30d/preview"
        },
        {
          "key": "essential_60",
          "icon": "pi-star",
          "title": "Essential 60",
          "description": "A curated shortlist of 60 questions, from JavaScript utilities to system design.",
          "route": "/interview-questions/essential"
        },
        {
          "key": "system_design_blueprint",
          "icon": "pi-share-alt",
          "title": "System design blueprint",
          "description": "A 45-minute answer template with a checklist, worked examples and real prompts.",
          "route": "/guides/system-design-blueprint"
        }
      ]
    },
    {
      "id": "practice",
      "label": "Practice",
      "items": [
        {
          "key": "interview_questions",
          "icon": "pi-question-circle",
          "title": "Interview Questions",
          "description": "Questions and answers by framework and round: coding, debugging, UI and system design.",
          "route": "/interview-questions",
          "chips": [
            { "key": "javascript", "label": "JavaScript", "route": "/javascript/interview-questions" },
            { "key": "react", "label": "React", "route": "/react/interview-questions" },
            { "key": "angular", "label": "Angular", "route": "/angular/interview-questions" },
            { "key": "vue", "label": "Vue", "route": "/vue/interview-questions" },
            { "key": "html", "label": "HTML", "route": "/html/interview-questions" },
            { "key": "css", "label": "CSS", "route": "/css/interview-questions" }
          ]
        },
        {
          "key": "question_library",
          "icon": "pi-bolt",
          "title": "Question Library",
          "description": "Every coding challenge in one place, with in-browser editing, tests and filters.",
          "route": "/coding"
        },
        {
          "key": "machine_coding",
          "icon": "pi-th-large",
          "title": "Machine coding",
          "description": "Build interview-style UI, from widgets and forms to tables and async flows.",
          "route": "/machine-coding"
        },
        {
          "key": "system_design",
          "icon": "pi-sitemap",
          "title": "Frontend system design",
          "description": "Architecture prompts with worked examples, RADIO drills and scoring rubrics.",
          "route": "/system-design"
        }
      ]
    },
    {
      "id": "focused",
      "label": "Focused practice",
      "items": [
        {
          "key": "study_plans",
          "icon": "pi-directions-alt",
          "title": "Study Plans",
          "description": "Guided 7-day and 30-day tracks with weekly checkpoints.",
          "route": "/tracks"
        },
        {
          "key": "companies",
          "icon": "pi-building",
          "title": "Company guides",
          "description": "Company-style practice for Google, Meta, Amazon, OpenAI and more.",
          "route": "/companies"
        },
        {
          "key": "focus_areas",
          "icon": "pi-filter",
          "title": "Focus areas",
          "description": "Pick a weak area and jump straight to its prep path.",
          "route": "/focus-areas"
        },
        {
          "key": "tradeoffs",
          "icon": "pi-sliders-h",
          "title": "Tradeoff questions",
          "description": "Defend choices like Context vs Redux, SSE vs WebSocket and CSR vs SSR.",
          "route": "/tradeoffs"
        },
        {
          "key": "incidents",
          "icon": "pi-exclamation-triangle",
          "title": "Debugging incidents",
          "description": "Trace a production-style bug to its root cause, fix it and guard against regressions.",
          "route": "/incidents"
        }
      ]
    },
    {
      "id": "guides",
      "label": "Guides and tools",
      "items": [
        {
          "key": "framework_prep",
          "icon": "pi-compass",
          "title": "Framework prep paths",
          "description": "7, 14 and 30-day paths for JavaScript, React, Angular and Vue interviews.",
          "route": "/guides/framework-prep"
        },
        {
          "key": "behavioral",
          "icon": "pi-comments",
          "title": "Behavioral interview guide",
          "description": "Story frameworks and example answers for behavioral rounds.",
          "route": "/guides/behavioral"
        },
        {
          "key": "cv_linter",
          "icon": "pi-file",
          "title": "CV Linter",
          "description": "An ATS-style resume score with section fixes and keyword gaps.",
          "route": "/tools/cv"
        }
      ]
    }
  ]
}
